/* ==========================================================================
   Design Process page
   - Showcase: category filter buttons.
   - Sketch-to-final: drag slider that reveals the sketch over the finished
     piece.
   - Design journey: highlights the step in view in the sticky navigator.
   Safe to include from several sections: the script runs once, and each
   section is set up again when the theme editor re-renders it.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__dpLoaded) return;
  window.__dpLoaded = true;

  function once(el) {
    if (el.dataset.dpReady) return false;
    el.dataset.dpReady = '1';
    return true;
  }

  function initFilters(root) {
    root.querySelectorAll('[data-dp-filters]').forEach(function (bar) {
      if (!once(bar)) return;

      var scope = bar.closest('.dp');
      var pieces = scope.querySelectorAll('[data-dp-category]');

      bar.addEventListener('click', function (event) {
        var button = event.target.closest('[data-dp-filter]');
        if (!button) return;
        var value = button.getAttribute('data-dp-filter');

        bar.querySelectorAll('[data-dp-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === button));
        });

        pieces.forEach(function (piece) {
          var match = value === 'all' || piece.getAttribute('data-dp-category') === value;
          piece.hidden = !match;
          if (match) piece.classList.add('is-visible');
        });
      });
    });
  }

  function initCompare(root) {
    root.querySelectorAll('[data-dp-compare]').forEach(function (box) {
      if (!once(box)) return;

      var range = box.querySelector('input[type="range"]');
      if (!range) return;

      function update() { box.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', update);
      update();
    });
  }

  function initJourney(root) {
    if (!('IntersectionObserver' in window)) return;

    root.querySelectorAll('[data-dp-journey-nav]').forEach(function (nav) {
      if (!once(nav)) return;

      var links = {};
      nav.querySelectorAll('[data-dp-step-link]').forEach(function (link) {
        links[link.getAttribute('data-dp-step-link')] = link;
      });

      function setCurrent(id) {
        Object.keys(links).forEach(function (key) {
          if (key === id) links[key].setAttribute('aria-current', 'step');
          else links[key].removeAttribute('aria-current');
        });
      }

      // A step counts as current once it crosses the middle of the screen.
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setCurrent(entry.target.id);
        });
      }, { rootMargin: '-45% 0px -50% 0px' });

      Object.keys(links).forEach(function (id) {
        var step = document.getElementById(id);
        if (step) observer.observe(step);
      });

      var first = Object.keys(links)[0];
      if (first) setCurrent(first);
    });
  }

  // Sections re-rendered in the theme editor are not seen by theme.js's
  // scroll observer, so show their animated items straight away.
  function revealAll(root) {
    root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  function init(root) {
    initFilters(root);
    initCompare(root);
    initJourney(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    revealAll(event.target);
  });
})();
